export var textStyles = {
  display1Semi: {
    fontSize: {
      xs: '40px',
      s: '48px'
    },
    lineHeight: {
      xs: '48px',
      s: '60px'
    },
    fontWeight: 600
  },
  display2Semi: {
    fontSize: {
      xs: '32px',
      s: '40px'
    },
    lineHeight: {
      xs: '40px',
      s: '48px'
    },
    fontWeight: 600
  },
  display2: {
    fontSize: {
      xs: '32px',
      s: '40px'
    },
    lineHeight: {
      xs: '40px',
      s: '48px'
    },
    fontWeight: 400
  },
  heading1Semi: {
    fontSize: {
      xs: '24px',
      s: '32px'
    },
    lineHeight: {
      xs: '32px',
      s: '40px'
    },
    fontWeight: 600
  },
  heading2Semi: {
    fontSize: {
      xs: '22px',
      s: '24px'
    },
    lineHeight: {
      xs: '32px',
      s: '32px'
    },
    fontWeight: 600
  },
  heading2: {
    fontSize: {
      xs: '22px',
      s: '24px'
    },
    lineHeight: {
      xs: '32px',
      s: '32px'
    },
    fontWeight: 400
  },
  heading3Semi: {
    fontSize: {
      xs: '20px',
      s: '20px'
    },
    lineHeight: {
      xs: '28px',
      s: '28px'
    },
    fontWeight: 600
  },
  body1Semi: {
    fontSize: {
      xs: '20px',
      s: '20px'
    },
    lineHeight: {
      xs: '28px',
      s: '28px'
    },
    fontWeight: 600
  },
  body1: {
    fontSize: {
      xs: '20px',
      s: '20px'
    },
    lineHeight: {
      xs: '28px',
      s: '28px'
    },
    fontWeight: 400
  },
  body2Semi: {
    fontSize: {
      xs: '18px',
      s: '16px'
    },
    lineHeight: {
      xs: '24px',
      s: '24px'
    },
    fontWeight: 600
  },
  body2: {
    fontSize: {
      xs: '18px',
      s: '16px'
    },
    lineHeight: {
      xs: '24px',
      s: '24px'
    },
    fontWeight: 400
  },
  body3Semi: {
    fontSize: {
      xs: '16px',
      s: '14px'
    },
    lineHeight: {
      xs: '24px',
      s: '20px'
    },
    fontWeight: 600
  },
  body3: {
    fontSize: {
      xs: '16px',
      s: '14px'
    },
    lineHeight: {
      xs: '24px',
      s: '20px'
    },
    fontWeight: 400
  },
  body4Semi: {
    fontSize: {
      xs: '14px',
      s: '12px'
    },
    lineHeight: {
      xs: '20px',
      s: '16px'
    },
    fontWeight: 600
  },
  body4: {
    fontSize: {
      xs: '14px',
      s: '12px'
    },
    lineHeight: {
      xs: '20px',
      s: '16px'
    },
    fontWeight: 400
  },
  body4SemiUpper: {
    fontSize: {
      xs: '14px',
      s: '12px'
    },
    lineHeight: {
      xs: '20px',
      s: '16px'
    },
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.4px'
  },
  body5SemiUpper: {
    fontSize: {
      xs: '12px',
      s: '10px'
    },
    lineHeight: {
      xs: '16px',
      s: '16px'
    },
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.4px'
  },
  caption1Semi: {
    fontSize: {
      xs: '12px',
      s: '10px'
    },
    lineHeight: {
      xs: '16px',
      s: '14px'
    },
    fontWeight: 600,
    letterSpacing: '0.2px'
  },
  caption1: {
    fontSize: {
      xs: '12px',
      s: '10px'
    },
    lineHeight: {
      xs: '16px',
      s: '14px'
    },
    fontWeight: 400,
    letterSpacing: '0.2px'
  },
  caption1SemiUpper: {
    fontSize: {
      xs: '12px',
      s: '10px'
    },
    lineHeight: {
      xs: '16px',
      s: '14px'
    },
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.2px'
  },
  caption2Semi: {
    fontSize: {
      xs: '11px',
      s: '8px'
    },
    lineHeight: {
      xs: '16px',
      s: '12px'
    },
    fontWeight: 600,
    letterSpacing: '0.2px'
  },
  inline: {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    fontWeight: 'inherit'
  }
}; // eslint-disable-next-line @typescript-eslint/ban-types

export var getTextStyleKeys = () => Object.keys(textStyles);
export var getTextStyle = (theme, key) => {
  var _theme$textStyles;

  return theme === null || theme === void 0 ? void 0 : (_theme$textStyles = theme.textStyles) === null || _theme$textStyles === void 0 ? void 0 : _theme$textStyles[key];
};
//# sourceMappingURL=text-styles.js.map